module.exports = __webpack_public_path__ + "static/media/calendar_icon.5d84de52.svg";